import { GraphColourArray } from "../common/enums/GraphColours";
export const BAR_CHART_COLORS = [
  "#E37B17",
  "#DBE794",
  "#097896",
  "#00475A",
  "#91C840",
]

export const IS_RECONCILED_FLAG = 'isReconciled'
export const BAR_CHART_OPTIONS = {
    grid: { containLabel: true , left: '10%'},
    xAxis: {
      axisLabel: {
        formatter: "",
        fontSize: 18
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'category',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel:{ fontSize: 18 }
    },
    color: GraphColourArray,
    series: [
      {
        type: 'bar',
        encode: {
          x: 'percentage',
          y: 'asset'
        },
        color: GraphColourArray,
        label: {
          show: true,
          position: 'right',
          formatter: "{@percentage}%",
          fontSize: 18
        },
        barWidth: 60,
        data: []
      }
    ]
  };


// WEBPACK FOOTER //
// ./src/app/reporting/constants.ts